import gql from "graphql-tag";

export const GET_DOWNLOAD_ICON = gql`
    mutation downloadIcon(
        $iconId: ID!
        $exportSize: Int
        $imageFormat: IconFileType
        $foregroundColor: String
        $backgroundShapeColor: String
        $backgroundShapeOpacity: Float
        $backgroundShape: IconBackgroundShape
        $rotation: Int
        $flipX: Boolean
        $flipY: Boolean
    ) {
        downloadIcon(
            iconId: $iconId
            exportSize: $exportSize
            imageFormat: $imageFormat
            foregroundColor: $foregroundColor
            backgroundShapeColor: $backgroundShapeColor
            backgroundShapeOpacity: $backgroundShapeOpacity
            backgroundShape: $backgroundShape
            rotation: $rotation
            flipX: $flipX
            flipY: $flipY
        ) {
            ok
            errors
            base64Stream
        }
    }
`;
